/**
 * Get the webapp version information
 * @returns {Object} Version information object
 */
export function getVersionInfo() {
  const webAppVersion = process.env.NEXT_PUBLIC_WEBAPP_VERSION || `${'0.0.0'}+${'unknown'}`;

  return {
    webAppVersion,
    buildTime: new Date().toISOString(),
  };
}

/**
 * Get just the webapp version string
 * @returns {string} The webapp version
 */
export function getWebappVersion() {
  return getVersionInfo().webAppVersion;
}
